// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimMarketingReferenceInfo from './claim-marketing-reference-info';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimJdPromise = t.struct({
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    deliveryDate: t.maybe(t.Number),
    errors: t.list(ClaimVsrMessage, 'Errors'),
    failurePartNumber: t.String,
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    jdpComments: t.String,
    jdpCustomerResolution: KeyValuePair,
    jdpReason: KeyValuePair,
    model: t.maybe(t.String),
    pin: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimMarketingReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    returnDate: t.maybe(t.Number),
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    subClaimType: KeyValuePair,
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimJdPromise',
    strict: true
});

export const getDefaultState = () => new ClaimJdPromise({
    allowedActions: [
        new ClaimAction({
            actionName: 'SAVE_VALD',
            id: 'SAVE_VALD',
            mode: 'CHG'
        })
    ],
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZZMK',
        value: ''
    }),
    claimValueDetails: getClaimValueDetailsDefaultState(),
    deliveryDate: null,
    errors: [],
    failurePartNumber: '',
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    isDuplicateClaim: false,
    isEditable: true,
    jdpComments: '',
    jdpCustomerResolution: getKeyValuePairDefaultState(),
    jdpReason: getKeyValuePairDefaultState(),
    model: '',
    pin: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: new ClaimMarketingReferenceInfo({
        referenceNumber1: '',
        repairNumber: ''
    }),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    returnDate: null,
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    subClaimType: new KeyValuePair({
        key: 'JDP',
        value: ''
    }),
    validationFailed: false,
    version: ''
});

ClaimJdPromise.prototype.vsrErrorMessages = function vsrErrorMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

    return errorMessages;

};

ClaimJdPromise.prototype.vsrWarningMessages = function vsrWarningMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

    return errorMessages;

};

ClaimJdPromise.prototype.vsrInfoMessages = function vsrInfoMessages() {

    const errorMessages = this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

    return errorMessages;

};

export default ClaimJdPromise;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-jd-promise.js